import { useCurrentGroup } from "hooks/useCurrentGroup";
import { useGetTaskSeasonsQuery } from "store/apis/filing";

const EMPTY_SEASONS: string[] = [];

export const useChatSeasons = (): string[] => {
  const { uuid: groupId } = useCurrentGroup();

  const { data } = useGetTaskSeasonsQuery(
    { groupId: groupId! },
    { skip: !groupId }
  );

  return data?.seasons || EMPTY_SEASONS;
};
